module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Opening-Text-No-Indent-cotx1"
  }, [_vm._v("Thanks to: Louise Maker, Mark Duncan, Marina Hardiman, Annalisa Ferrarotto, Stephen Coates, Nicola Stewart, Jonathan Field, Vicky Hutchinson, Peter Sollett, Eva Vives, Mike Loteryman, Anna Baker-Jones, Alice Naylor, Susanna Moore, Charles Spicer, and Deborah Schneider.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0